import { render, staticRenderFns } from "./QuickReplies.vue?vue&type=template&id=6a5c8b36"
import script from "./QuickReplies.vue?vue&type=script&lang=ts"
export * from "./QuickReplies.vue?vue&type=script&lang=ts"
import style0 from "./QuickReplies.vue?vue&type=style&index=0&id=6a5c8b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports